import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import QuizQuestions from '@/components/course/QuizQuestions.vue'
  import useCourse from '@/composables/useCourse'
  import useEditor from '@/composables/useEditor'
  import type { EditorQuestion } from '@/services/interfaces/Course'
  import { CourseModule } from '@/store/modules/course'
  import { EditorModule } from '@/store/modules/editor'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonQuestionsTabView',
  setup(__props) {

  const route = useRoute()
  const { currentLesson, currentLessonQuestions: courseLessonQuestions } = useCourse()
  const { currentQuizQuestions, currentLessonQuestions } = useEditor(route)

  const lessonQuizQuestions = computed(() => {
    return (currentQuizQuestions.value?.filter((q) => q._destroy !== true) || []) as EditorQuestion[]
  })

  const lessonQuestions = computed(() => {
    return (currentLessonQuestions.value?.filter((q) => q._destroy !== true) || []) as EditorQuestion[]
  })

  const originalQuizQuestions = computed(() => CourseModule.originalQuizQuestions)

  CourseModule.setQuizQuestions(originalQuizQuestions.value)
  EditorModule.setQuizQuestions(originalQuizQuestions.value)

  const addQuizQuestion = (question: EditorQuestion) => {
    ;(currentQuizQuestions.value as EditorQuestion[])!.push(question)
  }

  const addLessonQuestion = (question: EditorQuestion) => {
    ;(currentLessonQuestions.value as EditorQuestion[])!.push(question)
  }

  const removeNewQuizQuestion = (index: number) => {
    const deleteIndex = (currentQuizQuestions.value as EditorQuestion[])?.findIndex(
      (q) => q.editorId === lessonQuizQuestions.value[index]?.editorId,
    )
    return deleteIndex > -1 ? currentQuizQuestions.value!.splice(deleteIndex, 1) : []
  }

  const removeNewLessonQuestion = (index: number) => {
    const deleteIndex = (currentLessonQuestions.value as EditorQuestion[])?.findIndex(
      (q) => q.editorId === lessonQuestions.value[index]?.editorId,
    )
    return deleteIndex > -1 ? currentLessonQuestions.value!.splice(index, 1) : []
  }

return { __sfc: true,route, currentLesson, courseLessonQuestions, currentQuizQuestions, currentLessonQuestions, lessonQuizQuestions, lessonQuestions, originalQuizQuestions, addQuizQuestion, addLessonQuestion, removeNewQuizQuestion, removeNewLessonQuestion, computed, QuizQuestions, useCourse, useEditor, CourseModule, EditorModule, useRoute }
}

})